<template>
  <base-nav
    v-model="showMenu"
    class="navbar-absolute top-navbar"
    type="white"
    :transparent="true"
    containerClasses="container-fluid pl-0">
    <div slot="brand" class="navbar-wrapper">
      <div v-if="hasSidebar" class="navbar-minimize d-inline"><sidebar-toggle-button /></div>
      <div
        class="navbar-toggle d-inline"
        :class="{ toggled: $sidebar.showSidebar }">
        <button type="button" class="navbar-toggler" @click="toggleSidebar" :title="title">
          <span class="navbar-toggler-bar bar1"></span>
          <span class="navbar-toggler-bar bar2"></span>
          <span class="navbar-toggler-bar bar3"></span>
        </button>
      </div>
      <span class="navbar-brand navbar-title">{{ title }}</span>
    </div>

    <ul v-if="showSurveyNav" class="navbar-nav">
      <li class="nav-item">
        <router-link to="/admin/surveys" class="nav-link">Surveys</router-link>
      </li>
      <base-dropdown
        v-if="hasAdminAccess"
        tag="li"
        title="Admin"
        title-tag="a"
        title-classes="nav-link"
        class="nav-item">
        <span slot="title">
          Administration &#9207;
        </span>
        <li class="nav-link">
          <a href="#" @click="goToUsers" class="nav-item dropdown-item">Admin Users</a>
        </li>
        <li class="nav-link">
          <a href="#" @click="goToSurveyUsers" class="nav-item dropdown-item">Survey Users</a>
        </li>
        <li v-if="isAdministrator" class="nav-link">
          <a href="#" @click="goToRoles" class="nav-item dropdown-item">Roles</a>
        </li>
        <li class="nav-link">
          <a href="#" @click="goToLinks" class="nav-item dropdown-item">Links</a>
        </li>
        <li class="nav-link">
          <a href="#" @click="goToReportFiles" class="nav-item dropdown-item">Report Files</a>
        </li>
      </base-dropdown>
    </ul>
    
    <ul class="navbar-nav ml-auto">
      <b>{{ adminUserName }}</b>{{ displayVersion }}
      <base-dropdown
        tag="li"
        :menu-on-right="false"
        title-tag="a"
        class="nav-item"
        title-classes="nav-link"
        menu-classes="dropdown-navbar">
        <template slot="title">
          <i class="tim-icons icon-single-02"></i>
          <b class="caret d-none d-lg-block d-xl-block"></b>
          <p class="d-lg-none">Log out</p>
        </template>
        <li class="nav-link">
          <a href="#" @click="logout" class="nav-item dropdown-item">Log out</a>
        </li>
      </base-dropdown>
    </ul>

    <ul v-if="isAdministrator || enableColorSchemeChange" class="navbar-nav"><sidebar-share @darkModeToggled="handleDarkModeToggled"/></ul>
  </base-nav>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { BaseNav } from '@/components';
  import SidebarToggleButton from '../Layout/SidebarToggleButton';
  import SidebarShare from '../Layout/SidebarSharePlugin';
  import BaseDropdown from '../../components/BaseDropdown.vue';
  import { signoutUser } from '../../modules/adminActions';
  import { isDarkModeMedia, preventDarkMode, isNullOrEmpty } from 'src/modules/utils';

  export default {
    components: {
      SidebarToggleButton,
      SidebarShare,
      BaseNav,
      BaseDropdown
    },
    props: {
      hasSidebar: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: 'HSP'
      }
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',

        // Debugging variables
        enableColorSchemeChange: false,  // Whether to display the color scheme change plugin (change between dark and light mode)
        enableDarkMode: false,  // Whether or not you can change the color scheme to dark mode using the plugin
      };
    },
    computed: {
      routeName() {
        const { title } = this.$route.meta;
        return title;
      },
      hasAdminAccess() {
        return this.isAdministrator || this.hasRole('analyst');
      },
      isAdministrator() {
        return this.hasRole('administrator');
      },
      isSurveyAdmin() {
        return !this.adminUserIsUser;
      },
      showSurveyNav() {
        if (this.isSurveyAdmin || isNullOrEmpty(this.userAssignments) || (this.userAssignments.numberOfSurveys > 1 && this.userAssignments.numberOfSurveyInstances > 1)) {
          return true;
        }

        return false;
      },
      displayVersion() {
        return this.isAdministrator && !isNullOrEmpty(process.env.VUE_APP_VERSION) ? ` (web app v${process.env.VUE_APP_VERSION})` : "";
      },
      ...mapGetters(['hasRole','adminUserName','adminUserIsUser','userAssignments'])
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      goToUsers() {
        let path = '/admin/users';

        if(this.$route.path !== path)
          this.$router.push({ path: '/admin/users' });
      },
      goToRoles() {
        let path = '/admin/roles';

        if(this.$route.path !== path)
          this.$router.push({ path: '/admin/roles' });
      },
      goToLinks() {
        let path = '/admin/links';

        if(this.$route.path !== path)
          this.$router.push({ path: '/admin/links' });
      },
      goToReportFiles() {
        let path = '/admin/reportfiles';

        if(this.$route.path !== path)
          this.$router.push({ path: '/admin/reportfiles' });
      },
      goToSurveyUsers() {
        let path = '/admin/surveyusers';

        if(this.$route.path !== path)
          this.$router.push({ path: path });
      },
      logout() {
        signoutUser()
          .then(() => {
            this.$router.push({ path: '/admin' });
          })

      },
      handleDarkModeToggled(darkMode) {
        if (!this.enableDarkMode) {
          preventDarkMode();
        }
      },
    },
  };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
  .navbar-title {
    margin-left: 0px !important;
  }
  .dropdown-item.active {
    background-color: #fff;
  }
</style>
